'use strict';

var _ = require('lodash');
var moment = require('moment');
var toastr = require('toastr');
var GridDropdownPopulateService = function GridDropdownPopulateService($log, configurationService, urdFlightDropdownValues, urdMarketDropdownValues, configurationParametersControlTypeService, featureToggleService, hepService, fcrService, configurationParametersAdvancedService) {
  var airlines = configurationService.getHostCarrier().split(',');
  var specialEventMarkets = [];
  var specialEventNames = [];
  var applicableSeasons = {};
  var daPoses = _.chain(configurationService.getDaPoses()).transform(function (result, current) {
    result.push(current.spos);
  }).uniq().sortBy().value();
  function getApplicableSeasonsDropdownValues(row) {
    var key = '';
    if (row.market) {
      key = row.market + ':UntruncatedMarketDemand';
    } else if (row.leg) {
      key = row.leg + ':LegShowUpMetrics';
    }
    return _.concat([''], _.filter(applicableSeasons[key], function (item) {
      return item !== row.season;
    }));
  }
  function resetApplicableSeasons() {
    applicableSeasons = {};
  }
  function getApplicableSeasons(key) {
    return applicableSeasons[key];
  }
  function setApplicableSeasons(key, seasons) {
    applicableSeasons[key] = seasons;
  }
  function setSpecialEventMarkets(selectedMarkets) {
    specialEventMarkets = selectedMarkets;
  }
  function setSpecialEventNames(eventNames) {
    specialEventNames = eventNames;
  }
  function getNonCodeShareMarketsValues(transformer) {
    return _.chain(configurationService.getNonCodeShareMarkets()).transform(transformer).uniq().sortBy().value();
  }
  function nonCodeShareMarketPropTransformer(propType) {
    return function (result, current) {
      result.push(current[propType]);
    };
  }
  function getDropdownValues(columnId, jqxGridColumnId, row, loadedData, fieldVariant) {
    if (fieldVariant) {
      columnId = _.join([columnId, fieldVariant], ':');
      jqxGridColumnId = _.join([jqxGridColumnId, fieldVariant], ':');
    }
    switch (jqxGridColumnId) {
      case 'configuration-host-share-dayOfWeek':
        return _.chain(moment.weekdays()).transform(function (collection, dow) {
          collection.push(dow.toUpperCase());
        }, []).value();
      case 'cabin-flight-analysis-post-departure-ignorePostDepartureDataStatus':
        return ['Include', 'Exclude'];
      case 'configuration-leg-assignment-entityAssignment':
      case 'configuration-flight-assignment-entityAssignment':
        return _.chain(configurationService.getEntities()).filter({
          type: 'Flight'
        }).transform(function (result, current) {
          result.push(current.description);
        }).sortBy().value();
      case 'configuration-market-assign-entityAssignment':
        return _.chain(configurationService.getEntities()).filter({
          type: 'Market'
        }).transform(function (result, current) {
          result.push(current.description);
        }).value();
      case 'configuration-market-assign-controlType':
        return ['physical', 'financial'];
      case 'configuration-budget-target-spos':
        if (row && row.marketOrigin && row.marketDestination) {
          return _.transform(configurationService.getPoses(), function (result, current) {
            if (current.origin === row.marketOrigin && current.destination === row.marketDestination) {
              result.push(current.spos);
            }
          });
        }
        return [];
      case 'system-status-fares-reopt-market':
        if (row && row.pos) {
          return _.chain(configurationService.getPoses()).transform(function (result, current) {
            if (current.spos === row.pos && result.indexOf(current.origin + '-' + current.destination) === -1) {
              result.push(current.origin + '-' + current.destination);
            }
          }).uniq().sortBy().value();
        }
        return [];
      case 'configuration-budget-target-marketOrigin':
      case 'configuration-flight-assignment-origin':
      case 'configuration-leg-assignment-origin':
      case 'configuration-host-share-origin':
        return getNonCodeShareMarketsValues(nonCodeShareMarketPropTransformer('origin'));
      case 'configuration-discontinued-routes-connectingServices':
        return ['N/A', 'All connections', 'More than 1 connections', 'More than 2 connections'];
      case 'configuration-budget-target-marketDestination':
      case 'configuration-flight-assignment-destination':
      case 'configuration-leg-assignment-destination':
      case 'configuration-host-share-destination':
        return getNonCodeShareMarketsValues(nonCodeShareMarketPropTransformer('destination'));
      case 'configuration-host-share-month':
        return ['', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
      case 'seasonality-new-calendar-special-events-market':
        return specialEventMarkets;
      case 'configuration-user-defined-ref-data-market-status':
      case 'configuration-user-defined-ref-data-flight-status':
        return ['ACTIVE', 'INACTIVE'];
      case 'configuration-user-defined-ref-data-market-referenceMetric':
        if (featureToggleService.isEnabled('MAPPED_MODE')) {
          return ['Regular Bookings', 'Regular Revenue', 'Regular Yield', 'Regular FC Demand', 'Mapped Bookings', 'Mapped Revenue', 'Mapped Yield', 'Mapped FC Demand'];
        }
        return ['Bookings', 'Revenue', 'Yield', 'Demand'];
      case 'configuration-parameters-advanced-modal-fareType':
        return ['YQ FLAT', 'YQ PERCENT', 'YR FLAT', 'YR PERCENT', 'TAX FLAT', 'TAX VARIABLE - BASE', 'TAX VARIABLE - YQ', 'TAX VARIABLE TAX AMOUNT', 'TAX VARIABLE - YR', 'AIRPORT/TERM - A', 'BUSINESS CLASS - B', 'PEAK TRAVEL TIME - D', 'FUEL - F', 'PEAK - G', 'HOLIDAY - H', 'SEASONAL - J', 'SLEEPERETTE - L', 'WAIVER FOR ADV PURCHASE REQUIREMENTS - M', 'NAVIGATION - N', 'SECURITY - O', 'MAXIMUM STAY WAIVER - P', 'MISCELLANEOUS/OTHER - Q', 'RBD - Z'];
      case 'configuration-parameters-advanced-modal-inOrOutBoundType':
        return ['IB', 'OB'];
      case 'configuration-parameters-advanced-modal-level':
        return ['1', '2'];
      case 'configuration-user-defined-ref-data-market-market':
      case 'configuration-user-defined-ref-data-market-marketEntity':
        return urdMarketDropdownValues.getDropdownValues(columnId, row);
      case 'configuration-user-defined-ref-data-market-dowGroup':
        return _.transform(configurationService.getMarketDowGroups(), function (result, current) {
          result.push(current.name);
        });
      case 'configuration-user-defined-ref-data-market-marketProduct':
        return urdMarketDropdownValues.getProductGroupDropdownValues(row);
      case 'configuration-user-defined-ref-data-flight-referenceMetric':
        if (featureToggleService.isEnabled('SEGMENT_CLASS_CONTROL')) {
          return ['Load Factor', 'Capacity', 'Total bookings', 'Group bookings', 'Revenue', 'Yield', 'RASD', 'RPD'];
        }
        return ['Load Factor', 'Availability', 'Capacity', 'Total bookings', 'Group bookings', 'Revenue', 'Yield', 'RASD', 'RPD'];
      case 'configuration-user-defined-ref-data-flight-airline':
      case 'configuration-user-defined-ref-data-flight-flightEntity':
      case 'configuration-user-defined-ref-data-flight-flightLeg':
      case 'configuration-user-defined-ref-data-flight-flightNumber':
        return urdFlightDropdownValues.getDropdownValues(columnId, row);
      case 'configuration-user-defined-ref-data-flight-dowGroup':
        return _.transform(configurationService.getFlightDowGroups(), function (result, current) {
          result.push(current.name);
        });
      case 'seasonality-special-events-eventName':
        return specialEventNames;
      case 'configuration-parameters-propertyValue':
        return configurationParametersControlTypeService.getDropdownValues(row.propertyName);
      case 'configuration-market-class-fare-influences-pos':
        return daPoses;
      case 'configuration-parameters-advanced-marketConfigParams_riaMethod':
        return ['Median', 'Weighted Avg'];
      case 'configuration-parameters-advanced-marketConfigParams_source':
        return ['All', 'Web Fares'];
      case 'configuration-parameters-advanced-marketConfigParams_noOfStop_operator':
      case 'configuration-parameters-advanced-marketConfigParams_minConnectionTime_operator':
      case 'configuration-parameters-advanced-marketConfigParams_maxConnectionTime_operator':
      case 'configuration-parameters-advanced-marketConfigParams_dtdBlackout_operator':
        return ['<', '<=', '>', '>=', '=', '!='];
      case 'configuration-parameters-advanced-modal-start_operator':
      case 'configuration-parameters-advanced-modal-end_operator':
        return ['='];
      case 'configuration-parameters-advanced-shoppingType':
        return ['ShoppingData', 'CompetitorFare'];
      case 'configuration-parameters-advanced-pricePositionStrategyParams_strategyType':
      case 'configuration-parameters-advanced-thresholdParams_thresholdType':
      case 'configuration-parameters-advanced-todParams_fareThresholdType':
        return ['A', 'P'];
      case 'configuration-parameters-advanced-marketConfigParams_isCodeShare':
      case 'configuration-parameters-advanced-marketConfigParams_isPOCandPOS':
      case 'configuration-parameters-advanced-marketConfigParams_isTOD':
      case 'configuration-parameters-advanced-marketConfigParams_isOneWay':
      case 'configuration-parameters-advanced-marketConfigParams_isShiftShopping':
      case 'configuration-parameters-advanced-marketConfigParams_isUseNGDS':
      case 'configuration-parameters-advanced-marketConfigParams_isDynamicPricingAdj':
      case 'configuration-parameters-advanced-marketConfigParams_isMlModelEnabled':
      case 'configuration-parameters-advanced-marketConfigParams_isFareBrandEnabled':
      case 'configuration-parameters-advanced-todParams_isRestrictUpsell':
      case 'configuration-parameters-advanced-todParams_checkByCarrier':
        return ['Yes', 'No'];
      case 'configuration-parameters-advanced-modal-bidPriceCappingMethod':
        return ['Backward Curve Floor', 'Entire Curve Floor', 'No Flooring'];
      case 'configuration-parameters-advanced-modal-method':
        return ['Distribute slack to the classes in proportion to class protections', 'No slack distribution', 'Distribute slack to top class', 'Distribute slack to the top 3 open classes', 'Distribute slack to the classes in proportion to class remaining demand', 'Distribute slack to the classes in proportion to class CER', 'Distribute slack to the bottom 3 open classes'];
      case 'configuration-parameters-advanced-todParams_bmCarrierSelection':
        return ['Total', 'Split'];
      case 'user-exclusion-rules-dows':
        return ['M', 'T', 'W', 'Th', 'F', 'Sa', 'Su'];
      case 'user-exclusion-rules-originAirport':
      case 'user-fbc-exclusion-rules-originAirport':
        return ['All'].concat(extractValues(configurationService.getMarkets(), ['origin']));
      case 'user-exclusion-rules-destinationAirport':
      case 'user-fbc-exclusion-rules-destinationAirport':
        return ['All'].concat(extractValues(configurationService.getMarkets(), ['destination']));
      case 'configuration-parameters-advanced-tripType':
        return ['Round Trip', 'One-Way'];
      case 'configuration-parameters-advanced-bookingVelocityPPSAdjustmentParams_ppsAdjustmentStrategy':
        return ['Replace', 'Adjust'];
      case 'configuration-parameters-advanced-bookingVelocityPPSAdjustmentParams_ppsAdjustmentType':
      case 'configuration-parameters-advanced-bvDeviationType':
        return ['A', 'P'];
      case 'configuration-parameters-advanced-bookingVelocityPPSAdjustmentParams_qsiAdjustmentStrategy':
        return ['Replace'];
      case 'configuration-parameters-advanced-bookingVelocityPPSAdjustmentParams_qsiAdjustmentType':
        return ['A'];
      case 'configuration-parameters-advanced-direction':
      case 'configuration-parameters-advanced-modal-direction':
        return ['Outbound', 'Inbound', 'Both'];
      case 'configuration-parameters-advanced-direction:exclusive':
        return ['Outbound', 'Inbound'];
      case 'configuration-parameters-advanced-modal-dtdCondition_operator':
        return ['>', '>=', '<', '<='];
      case 'configuration-parameters-advanced-bookingVelocityODAggregationParams_criticalFlight':
        return ['First', 'Second', 'Third', 'All'];
      case 'configuration-parameters-advanced-bookingVelocityODAggregationParams_ppsAggregationStrategy':
        return ['Min', 'Max', 'Avg', 'Sum', 'No action', 'Actual'];
      case 'user-fbc-exclusion-rules-fareClass':
        return ['All'].concat(configurationService.getClasses());
      case 'configuration-parameters-advanced-agregationLevel':
        return ['Month-DoW', 'Month', 'DoW', 'Market'];
      case 'holiday-and-special-events-origin':
        return [].concat(['All'], extractValues(configurationService.getMarkets(), ['origin']));
      case 'holiday-and-special-events-destination':
        return [].concat(['All'], extractValues(configurationService.getMarkets(), ['destination']));
      case 'holiday-and-special-events-eventType':
        return ['Fixed Date', 'Moving', 'Excluded'];
    }
    switch (columnId) {
      case 'origin':
      case 'marketOrigin':
      case 'neighborMarketOrigin':
      case 'originCity':
      case 'legOrigin':
      case 'sponsorOrigin':
      case 'targetOrigin':
        return extractValues(configurationService.getMarkets(), ['origin']);
      case 'foOrigin':
        var foOrigin = extractValues(configurationService.getMarkets(), ['origin']);
        foOrigin = foOrigin.concat(configurationService.getFoCountries());
        return _.remove(foOrigin, function (n) {
          return !_.isEqual(n, '');
        });
      case 'foDestination':
        var foDestination = extractValues(configurationService.getMarkets(), ['destination']);
        foDestination = foDestination.concat(configurationService.getFoCountries());
        return _.remove(foDestination, function (n) {
          return !_.isEqual(n, '');
        });
      case 'destination':
      case 'destinationCity':
      case 'marketDestination':
      case 'neighborMarketDestination':
      case 'legDestination':
      case 'sponsorDestination':
      case 'targetDestination':
        return extractValues(configurationService.getMarkets(), ['destination']);
      case 'foSponsorDestination':
      case 'foTargetDestination':
        var destination = [''];
        return destination.concat(extractValues(configurationService.getMarkets(), ['destination']));
      case 'airport':
        return extractValues(configurationService.getMarkets(), ['origin', 'destination']);
      case 'cityOrigin':
      case 'cityDestination':
        return configurationService.getFoCityCodes();
      case 'foSponsorOrigin':
      case 'foTargetOrigin':
        var origin = [''];
        return origin.concat(extractValues(configurationService.getMarkets(), ['origin']));
      case 'userName':
        return _.chain(configurationService.getAllUsers()).transform(function (result, current) {
          result.push(current.userId);
        }).uniq().sortBy().value();
      case 'originAirport':
      case 'destinationAirport':
        return configurationService.getFoAirportCodes();
      case 'spos':
      case 'pos':
      case 'destPos':
      case 'significantPOS':
        return _.chain(configurationService.getPoses()).transform(function (result, current) {
          result.push(current.spos);
        }).uniq().sortBy().value();
      case 'foPos':
      case 'originCountry':
      case 'destinationCountry':
        return configurationService.getFoPoses();
      case 'daPos':
        return daPoses;
      case 'isSignificant':
      case 'isLocal':
      case 'isTrafficRestricted':
      case 'isManuallyControlled':
      case 'useForAveraging':
      case 'clearDemandAdjsFlag':
      case 'isFimAlertEnabled':
      case 'isInterline':
        return ['Yes', 'No'];
      case 'month':
        return ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
      case 'dayOfWeek':
        return moment.weekdays();
      case 'inboundWeekendDefinition':
      case 'outboundWeekendDefinition':
        return ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
      case 'excludedDaysOfWeek':
      case 'approvedDaysOfWeek':
      case 'departureDateDaysOfWeek':
        return moment.weekdaysMin();
      case 'targetType':
        return ['Bookings', 'Yield', 'Revenue', 'GroupBookings', 'LoadFactor'];
      case 'flightNumberBegin':
      case 'flightNumberEnd':
      case 'ladderGenerationAPCheck':
      case 'isCat12Prefiled':
        return ['TRUE', 'FALSE'];
      case 'foSeasons':
        return configurationParametersAdvancedService.extractSeasonDetails().seasonsAbbreviation;
      case 'override':
        return ['TRUE', 'FALSE'];
      case 'inventoryAssignmentMethod':
        if (row.category === 'STRUCTURAL') {
          return ['ENTRY LEVEL RBD', 'RBD TO RBD', 'ORDINAL'];
        }
        return ['ENTRY LEVEL RBD', 'RBD TO RBD'];
      case 'ladderGenerationMethod':
        return ['LINEAR', 'EXPONENTIAL'];
      case 'flightNumber':
      case 'number':
        var flightNumbers = configurationService.getFlightNumbers();
        return _.chain(flightNumbers).transform(function (result, current) {
          result.push(current.flightNumber.toString());
        }).uniq().sortBy(function (flightNumber) {
          return parseInt(flightNumber);
        }).value();
      case 'carrier':
        if (row && row._old && _.has(row._old, 'addCompetitor')) {
          return _.uniq(_.concat(airlines, configurationService.getBenchmarkCarriers()));
        }
        return _.uniq(airlines);
      case 'processingCarrier':
        return configurationService.getConfiguredHostCarriers().split(',');
      case 'airline':
        return _.uniq(airlines);
      case 'airlineCode':
        return _.uniq(_.map(configurationService.getOperatingCarriers(), 'operatingCarrier'));
      case 'carrierCode':
        return _.uniq(configurationService.getHostAndSubsidiaryCarriers()).sort();
      case 'type':
        return ['Market', 'Flight'];
      case 'cabin':
      case 'cabinCode':
        return configurationService.getCabins();
      case 'linkedCabin':
        var cabin = [''];
        return cabin.concat(configurationService.getFoCabins());
      case 'foCabin':
        return configurationService.getFoCabins();
      case 'marketProduct':
      case 'classGroup':
        return configurationService.getClassGroups();
      case 'fareClass':
      case 'class':
        return configurationService.getClasses();
      case 'className':
        return fcrService.getClassesFcrSorted().reverse();
      case 'userTypeRegularRemainingDemandFC':
      case 'userTypeMappedRemainingDemandFC':
      case 'userAllocationType':
      case 'adjustmentType':
        return ['A', 'P'];
      //A is for absolute value type, P is for percentage value type
      case 'userSegmentLimitType':
        return ['BOTH', 'LOCAL', 'CONNECT'];
      case 'eventName':
        return _.map(configurationService.getEvents(), 'name');
      case 'eventType':
        return ['Fixed Date', 'Fixed WoY', 'Moving', 'Excluded'];
      case 'userOverSaleRiskLevel':
        return ['', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      case 'seasonOverride':
        return getApplicableSeasonsDropdownValues(row);
      case 'season':
      case 'demandSeason':
        return _.chain(configurationService.getSeasons()).transform(function (result, current) {
          result.push(current.name);
        }).value();
      case 'flightLeg':
        return _.chain(configurationService.getLegs()).transform(function (result, current) {
          result.push(current.origin + '-' + current.destination);
        }).value();
      case 'flightEntity':
      case 'entity':
        return _.chain(configurationService.getEntities()).filter({
          type: 'Flight'
        }).transform(function (result, current) {
          result.push(current.description);
        }).value();
      case 'flightCategoryParam_cabinControlIndicator':
        return ['FIXED', 'MOVABLE'];
      case 'curtainRuleId':
        hepService.loadCurtainRuleIds();
        return _.chain(configurationService.getCurtainRuleIds()).transform(function (result, current) {
          result.push(current);
        }).value();
      case 'flightCategory':
        hepService.loadFlightCategories();
        return _.chain(configurationService.getFlightCategories()).transform(function (result, current) {
          result.push(current);
        }).value();
      case 'private':
        return ['Public', 'Private'];
      case 'market':
        return _.chain(configurationService.getMarkets()).transform(function (result, current) {
          if (_.isNil(current.isSignificant) || !_.isNil(current.isSignificant) && current.isSignificant) {
            result.push(current.origin + '-' + current.destination);
          }
        }, []).uniq().sortBy().value();
      case 'fareBasisGroup':
        return ['Corporate', 'Private'];
      case 'fareBasisCodeMapping':
        return ['%CORP%', '%PRIV%'];
      case 'journeyType':
        return ['RT', 'OW'];
      case 'category':
        return ['STRUCTURAL', 'TACTICAL'];
      case 'marketListCategory':
        if (featureToggleService.isEnabled('DASHBOARD')) {
          return ['STRUCTURAL', 'TACTICAL', 'MONITOR'];
        }
        return ['STRUCTURAL', 'TACTICAL'];
      case 'taxOverridePriority':
        return ['HIGH', 'LOW'];
      case 'tripType':
        return ['1', '2', '3'];
      case 'fareChangeDirection':
        return ['', 'POSITIVE', 'NEGATIVE'];
      case 'strategy':
        return ['UNDERCUT', 'MATCH', 'PREMIUM'];
      case 'percentageIndicator':
      case 'upSellPercentageIndicator':
      case 'buyDownPercentageIndicator':
      case 'cardinalityThresholdPercentageIndicator':
        return ['A', 'P'];
      case 'benchmarkCarrier':
        if (!(row && row.origin && row.cabin && row.category)) {
          return [];
        }
        if (_.isNil(row.destination)) {
          return _.uniq(_.transform(configurationService.getFoBenchmarkCarriers(), function (result, current) {
            if (current.origin === row.origin && current.category === row.category && current.cabin === row.cabin) {
              _.forEach(current.benchmarkCarriers, function (benchmarkCarrier) {
                result.push(benchmarkCarrier);
              });
            }
          }));
        }
        return _.uniq(_.transform(configurationService.getFoBenchmarkCarriers(), function (result, current) {
          if (current.origin === row.origin && current.destination === row.destination && current.category === row.category && current.cabin === row.cabin) {
            _.forEach(current.benchmarkCarriers, function (benchmarkCarrier) {
              result.push(benchmarkCarrier);
            });
          }
        }));
      case 'foCarrier':
        return _.uniq(_.concat(airlines, configurationService.getConfiguredHostCarriers().split(','), _.flatten(_.map(configurationService.getFoBenchmarkCarriers(), 'benchmarkCarriers'))));
      case 'hostCarrier':
        return getHostCarriersBasedOnType(row.hepType);
      case 'foSponsorCarrier':
      case 'foTargetCarrier':
        return configurationService.getConfiguredHostCarriers().split(',');
      case 'neighborMarketCarriers':
        return _.uniq(_.concat(airlines, configurationService.getBenchmarkCarriers()));
      case 'foRbd':
        return configurationService.getFoRbds();
      case 'hostRbd':
        return getHostRbds(row);
      case 'rbd':
        return 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
      case 'foOriginCountry':
      case 'foDestCountry':
        return configurationService.getFoCountries();
      case 'foOriginRegion':
      case 'foDestRegion':
        return configurationService.getFoRegions();
      case 'currencyCode':
        return configurationService.getFoCurrencies();
      case 'propertyName':
        return ['POS', 'constant', 'variable', 'fbcPattern', 'fareBrand', 'fareType', 'Season'];
      case 'recommendationMatchType':
        return ['ALL', 'LOWEST'];
      case 'targetFareCalculationType':
        return ['A', 'P', 'BOTH'];
      case 'minimumGapCondition':
        return ['', 'A', 'P'];
      case 'sponsorFareTripType':
        return ['OW', 'RT', 'OWNC'];
      case 'sponsorFareTypeIndicator':
      case 'targetFareTypeIndicator':
      case 'targetFareTripType':
        return ['', 'OW', 'RT', 'OWNC'];
      case 'fareTypeIndicator':
      case 'hostFareTypeIndicator':
      case 'benchmarkFareTypeIndicator':
        return ['OW', 'RT', 'OWNC'];
      case 'surchargeType':
        return ['AIRPORT/TERM - A', 'BUSINESS CLASS - B', 'PEAK TRAVEL TIME - D', 'FUEL - F', 'PEAK - G', 'HOLIDAY - H', 'SEASONAL - J', 'SLEEPERETTE - L', 'WAIVER FOR ADV PURCHASE REQUIREMENTS - M', 'NAVIGATION - N', 'SECURITY - O', 'MAXIMUM STAY WAIVER - P', 'MISCELLANEOUS/OTHER - Q', 'RBD - Z'];
      case 'fareSource':
        return ['ATPCO', 'WEB'];
      case 'fareBrand':
      case 'hostFareBrand':
        return _.transform(configurationService.getFoFareBrandDefinitions(), function (result, current) {
          if (_.includes(_.uniq(airlines), current.carrier)) {
            _.forEach(_.chain(current.fareBrands).map('fareBrand').value(), function (fareBrand) {
              result.push(fareBrand);
            });
          }
        });
      case 'competitorFareBrand':
        return _.transform(configurationService.getFoFareBrandDefinitions(), function (result, current) {
          if ((!_.isNil(row.benchmarkCarrier) || !_.isNil(row.competitorAirline)) && (current.carrier === row.benchmarkCarrier || current.carrier === row.competitorAirline)) {
            _.forEach(_.chain(current.fareBrands).map('fareBrand').value(), function (fareBrand) {
              result.push(fareBrand);
            });
          }
        });
      case 'exclusionReasons':
        return configurationService.getFoShortRecommendationReasons();
      case 'inputSource':
        return ['ATPCO', 'GDS', 'WEB'];
      case 'inputType':
        return getInputTypeBasedOnInputSource(row.inputSource);
      case 'forecastType':
        return ['Market', 'Service'];
      case 'grouping':
        return ['Primary', 'Secondary'];
      case 'criteriaType':
        if (row.fareSource === 'WEB') {
          if (row.grouping === 'Primary') {
            return ['Amount', 'Date', 'RBD'];
          }
          return ['Date'];
        }
        if (row.grouping === 'Primary') {
          return ['Date', 'RBD', 'MMS', 'AP'];
        }
        return ['Date', 'AP'];
      case 'criteria':
        if (row.fareSource === 'WEB') {
          if (row.criteriaType === 'Amount') {
            return ['Total Fare', 'Base Fare'];
          }
          if (row.criteriaType === 'RBD') {
            return ['RBD'];
          }
          if (row.grouping === 'Primary' && row.criteriaType === 'Date') {
            return ['Departure Date'];
          }
          return ['Travel End Date (FN)'];
        } else if (row.criteriaType === 'Date') {
          return ['Sale End Date', 'Reservation End Date (Rule)', 'Ticketing End Date (Rule)', 'Travel End Date (Rule)', 'Reservation End Date (FN)', 'Ticketing End Date (FN)', 'Travel End Date (FN)'];
        } else if (row.criteriaType === 'RBD') {
          return ['RBD'];
        } else if (row.criteriaType === 'AP') {
          return ['AP-Res', 'AP-Tkt'];
        } else if (row.criteriaType === 'MMS') {
          return ['Min Stay', 'Max Stay'];
        }
        return ['Sale End Date', 'Reservation End Date (Rule)', 'Ticketing End Date (Rule)', 'Travel End Date (Rule)', 'Reservation End Date (FN)', 'Ticketing End Date (FN)', 'Travel End Date (FN)', 'RBD', 'AP-Res', 'AP-Tkt', 'Min Stay', 'Max Stay'];
      case 'operator':
        if (row.criteriaType === 'RBD') {
          return ['=', '!='];
        } else if (row.fareSource === 'WEB' && row.grouping === 'Primary') {
          return ['<', '='];
        }
        return ['=', '!=', '>', '>=', '<', '<='];
      case 'compMatch':
        if (row.grouping === 'Primary') {
          return [];
        }
        return ['TRUE', 'FALSE'];
      case 'sponsorFareBrand':
      case 'targetFareBrand':
        return _.transform(configurationService.getFoFareBrandDefinitions(), function (result, current) {
          if (_.includes(_.uniq(airlines), current.carrier)) {
            result.push('');
            _.forEach(_.chain(current.fareBrands).map('fareBrand').value(), function (fareBrand) {
              result.push(fareBrand);
            });
          }
        });
      case 'tariffCode':
        return configurationService.getFoTariffRules();
      case 'originAirportCountry':
      case 'destinationAirportCountry':
        return configurationService.getAirportCountryCodes();
      case 'daFareBrand':
      case 'fareBrandConfiguration':
        var fareBrandDefinitions = configurationService.getDAFareBrandDefinitions();
        if (_.isEmpty(fareBrandDefinitions)) {
          toastr.warning('No Fare Brand Definitions existing yet.');
          return [];
        } else if (!row.carrier) {
          toastr.warning('Please specify carrier.');
          return [];
        } else if (_.isEmpty(fareBrandDefinitions[row.carrier])) {
          toastr.warning('No Fare Brand Definition existing for carrier ' + row.carrier + '.');
          return [];
        }
        return fareBrandDefinitions[row.carrier];
      default:
        $log.warn('Dropdown values for columnId: ' + columnId + ' are not provided');
        return [];
    }
  }
  function getHostCarriersBasedOnType(hepType) {
    if (hepType === 'FOCabinClassConfig' || hepType === 'FOTacticalFBCPatternConfig' || hepType === undefined) {
      return configurationService.getConfiguredHostCarriers().split(',');
    }
    return [''].concat(configurationService.getConfiguredHostCarriers().split(','));
  }
  function getHostRbds(row) {
    var foCategoryCabinRbdsMapping = configurationService.getFoCategoryCabinRbdsMapping();
    if (_.isNil(row.category) || _.isNil(row.cabin) || _.isNil(foCategoryCabinRbdsMapping)) {
      return [''];
    }
    return configurationService.getFoCategoryCabinRbds(row, foCategoryCabinRbdsMapping, configurationService.getFoCategoryCabinRbdMappingKey(row, foCategoryCabinRbdsMapping));
  }
  function getInputTypeBasedOnInputSource(inputSource) {
    var inputTypes = [];
    if (inputSource === 'ATPCO') {
      inputTypes = ['BASE FARE', 'Q', 'QK'];
    } else if (inputSource === 'WEB' || inputSource === 'GDS') {
      inputTypes = ['BASE FARE', 'YQ', 'YR', 'OTHER'];
    }
    return inputTypes;
  }
  function extractValues(array, properties) {
    return _.chain(array).transform(function (result, current) {
      properties.forEach(function (prop) {
        result.push(current[prop]);
      });
    }).uniq().sortBy().value();
  }
  return {
    getDropdownValues: getDropdownValues,
    setSpecialEventMarkets: setSpecialEventMarkets,
    setSpecialEventNames: setSpecialEventNames,
    setApplicableSeasons: setApplicableSeasons,
    getApplicableSeasons: getApplicableSeasons,
    resetApplicableSeasons: resetApplicableSeasons
  };
};
GridDropdownPopulateService.$inject = ['$log', 'ConfigurationService', 'FlightDropdownValuesService', 'MarketDropdownValuesService', 'ConfigurationParametersControlTypeService', 'FeatureToggleService', 'HepService', 'FcrService', 'ConfigurationParametersAdvancedService'];
module.exports = GridDropdownPopulateService;